import React from 'react';

import PropTypes from 'prop-types';

import { EmailCTA } from 'reaxl-email';

import PricingBreakdown from '@/components/PricingBreakdown';

/**
 *  PricingBreakdownOffers has pricing data and available offers
 *
 */
function PricingBreakdownOffers({
    pricingDetail,
    hasOffer,
    className,
    showDealerAdjustment,
    emailCTAProps,
}) {
    return (
        <div
            data-cmp="pricingBreakdownOffers"
            className={className}
        >
            <PricingBreakdown
                data={pricingDetail}
                showDealerAdjustment={showDealerAdjustment}
            />
            {!!emailCTAProps && !!Object.keys(emailCTAProps).length && (
                <>
                    {hasOffer && (
                        <div className="margin-top-3 text-bold">
                            <EmailCTA
                                {...emailCTAProps}
                                context="incentives"
                                key="available-offers"
                                labelKey="viewAvailableOffers"
                                parentId="pricing-breakdown"
                                type="link"
                            />
                        </div>
                    )}
                    <EmailCTA
                        {...emailCTAProps}
                        buttonStyle={emailCTAProps.buttonStyle || 'secondary'}
                        className="margin-top-3"
                        context="availableOffers"
                        labelKey="contactDealer"
                        showIcon={false}
                        type="block"
                    />
                </>
            )}
        </div>
    );
}

PricingBreakdownOffers.propTypes = {
    /**
     * The className to apply to the root node
     */
    className: PropTypes.string, /**
     * A standard axl price data object with msrp and salePrice and an array of discount objects
     */
    pricingDetail: PropTypes.object, /**
     * If true, View Available Offers button will show
     */
    hasOffer: PropTypes.bool,
};

PricingBreakdownOffers.defaultProps = {
    pricingDetail: {},
    hasOffer: false,
};
export default PricingBreakdownOffers;
